import {useEffect, useState} from 'react';
import {useDispatcher} from '@netx/core-components/hooks/useDispatcher';

export type UseAssetTasksArguments = {
	assetId?: number;
};

// TODO: still needs cleanup but it works!
// TODO: need to keep track of any items globally
// we can use the global success/error calls to add/remove
// that way when a asset renders is can pick up here
export const useAssetTasksProgress = ({assetId}: UseAssetTasksArguments) => {
	const [isSaving, setIsSaving] = useState(false);
	const [progress, setProgress] = useState(0);
	// const [message, setMessage] = useState('');

	const [cacheBuster, setCachBuster] = useState<{assetTask: number}>();

	useEffect(() => {
		setIsSaving(false);
		setProgress(0);
	}, [assetId]);

	useDispatcher(`asset:tasks:error`, () => {
		setIsSaving(false);
	});

	useDispatcher(`asset:task:${assetId}:status`, (task: any) => {
		setIsSaving(true);
		setProgress(task.get('percentComplete'));
		// setMessage(task.get('message'));
	});

	useDispatcher(`asset:task:complete:${assetId}`, () => {
		dispatcher.trigger('asset:task:complete:hack', assetId);
		setProgress(100);
		setTimeout(() => {
			setIsSaving(false);
			setCachBuster({assetTask: Date.now()});
			setTimeout(() => {
				setProgress(0);
			}, 200);
		}, 200);
	});

	return {
		cacheBuster,
		isSaving,
		isWorking: isSaving,
		progress,
	};
};
